<template>
  <section class="co-surface co-realtime">
    <div class="co-section-head">
      <h2 class="co-section-title">
        Visão em tempo real
      </h2>
      <p class="co-section-desc">
        Indicadores atualizados automaticamente, sem depender do filtro de período histórico.
      </p>
    </div>

    <div class="co-metric-grid co-metric-grid--7">
      <div
        v-for="card in row1"
        :key="card.key"
        class="co-metric-card"
      >
        <span class="co-metric-card__value">{{ card.value }}</span>
        <span class="co-metric-card__label">{{ card.label }}</span>
      </div>
    </div>

    <div class="row co-realtime__row2">
      <div class="col-12 col-lg-7 mb-3 mb-lg-0">
        <CentralBotHighlight
          :headline="botHeadline"
          :bullets="botBullets"
          :highlighted="botHighlighted"
        />
      </div>
      <div class="col-12 col-lg-5">
        <div class="co-metric-card co-metric-card--tall">
          <span class="co-metric-card__value co-metric-card__value--sm">{{ avgWait }}</span>
          <span class="co-metric-card__label">Tempo médio atual de espera <span class="co-hint">(fila)</span></span>
        </div>
      </div>
    </div>

    <div class="co-narrative co-narrative--realtime">
      <p>{{ narrativeRealtime }}</p>
    </div>
  </section>
</template>

<script>
import CentralBotHighlight from './CentralBotHighlight.vue'

export default {
  name: 'CentralRealtimeSection',
  components: { CentralBotHighlight },
  props: {
    row1: {
      type: Array,
      default: () => [],
    },
    botHeadline: {
      type: String,
      default: '',
    },
    botBullets: {
      type: Array,
      default: () => [],
    },
    botHighlighted: {
      type: Boolean,
      default: true,
    },
    avgWait: {
      type: String,
      default: '—',
    },
    narrativeRealtime: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.co-surface {
  background: #faf8fc;
  border-radius: 24px;
  padding: 1.75rem 1.75rem 1.5rem;
  border: 1px solid rgba(106, 27, 154, 0.08);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
}

.co-section-head {
  margin-bottom: 1.5rem;
}

.co-section-title {
  margin: 0 0 0.35rem;
  font-size: 1.35rem;
  font-weight: 800;
  color: #4a148c;
  letter-spacing: -0.02em;
}

.co-section-desc {
  margin: 0;
  font-size: 0.9rem;
  color: #616161;
  max-width: 720px;
  line-height: 1.5;
}

.co-metric-grid {
  display: grid;
  gap: 0.85rem;
  margin-bottom: 1.25rem;
}

.co-metric-grid--7 {
  grid-template-columns: repeat(7, 1fr);
}

@media (max-width: 1400px) {
  .co-metric-grid--7 {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 992px) {
  .co-metric-grid--7 {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 576px) {
  .co-metric-grid--7 {
    grid-template-columns: 1fr 1fr;
  }
}

.co-metric-card {
  background: #fff;
  border-radius: 16px;
  padding: 1.1rem 1rem;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-height: 96px;
  justify-content: center;
}

.co-metric-card--tall {
  min-height: 140px;
  justify-content: center;
}

.co-metric-card__value {
  font-size: 1.75rem;
  font-weight: 800;
  color: #4a148c;
  line-height: 1.1;
  letter-spacing: -0.02em;
}

.co-metric-card__value--sm {
  font-size: 1.35rem;
}

.co-metric-card__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #757575;
  line-height: 1.35;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.co-hint {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 500;
  color: #9e9e9e;
}

.co-narrative {
  margin-top: 1.25rem;
  padding: 1.1rem 1.25rem;
  border-radius: 16px;
  background: linear-gradient(90deg, rgba(106, 27, 154, 0.06) 0%, rgba(255, 111, 97, 0.06) 100%);
  border: 1px solid rgba(106, 27, 154, 0.1);
}

.co-narrative p {
  margin: 0;
  font-size: 1rem;
  line-height: 1.55;
  color: #424242;
  font-weight: 500;
}

.co-realtime__row2 {
  margin-top: 0.25rem;
}
</style>
